import { createSlice } from "@reduxjs/toolkit";
import { fetchSurveyAssignments } from "redux/actions/survey/surveyAction";

const initialState = {
  surveyAssignmentList: [],
  surveyAssignmentListLoading: false,
  surveyAssignmentListTotalCount: 0,
  surveyAssignmentListError: false,
};

export const surveyAssignment = createSlice({
  name: "surveyAssignment",
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: {
    [fetchSurveyAssignments.pending]: (state) => {
      state.surveyAssignmentListLoading = true;
    },
    [fetchSurveyAssignments.fulfilled]: (state, { payload }) => {
      state.surveyAssignmentList = payload?.results;
      state.surveyAssignmentListTotalCount = payload?.count;
      state.surveyAssignmentListLoading = false;
    },
    [fetchSurveyAssignments.rejected]: (state) => {
      state.surveyAssignmentListLoading = false;
      state.surveyAssignmentListError = true;
    },
  },
});

export const { resetState } = surveyAssignment.actions;

export default surveyAssignment.reducer;
